export default __webpack_public_path__ + "static/media/coin_xrp.22cd7a32.svg";